import {
  Answers,
  DraftTask,
  Task,
  ValidationType,
  WorkModel,
} from 'models/task.model';
import { FileType } from 'interfaces';

export const TASK_TABS = {
  PREVIEW: 'task-preview',
  COMMENTS: 'task-comments',
} as const;

export type DraftTaskKeys = Record<keyof DraftTask, string>;
export type DraftTaskValidationField = Record<
  keyof Pick<
    DraftTaskKeys,
    | 'title'
    | 'description'
    | 'workModels'
    | 'answers'
    | 'errorMessage'
    | 'successMessage'
    | 'comment'
  >,
  string
>;

export type DraftPredefinedOptionsValidation = {
  predefinedOptionCorrectAnswer: string;
  predefinedOptionIncorrectAnswer: string;
};

export type TaskState = {
  tasks: Task[];
  draft: Task;
  answersByValidator: AnswersByValidator;
  errors: DraftTaskKeys & DraftPredefinedOptionsValidation;
  assignedGroup: Task['taskGroupId'];
  activeTaskTab: string;
};

export type DraftSetOptions = {
  markAsDirty: boolean;
  shouldValidate?: boolean;
};

export type AnswersByValidator = Partial<Record<ValidationType, Answers>>;

export type TaskActions = {
  actions: {
    setDraftTitle: (title: string, options?: DraftSetOptions) => void;
    setDraftDescription: (
      description: string,
      options?: DraftSetOptions,
    ) => void;
    setDraftPictures: (files: FileType[], options?: DraftSetOptions) => void;
    setDraftWorkModels: (
      workModels: WorkModel[],
      options?: DraftSetOptions,
    ) => void;
    setDraftQuestionAnswer: (answers: {
      correctAnswers: string[];
      incorrectAnswers: string[];
    }) => void;
    setDraftValidator: (
      validator: ValidationType,
      options?: DraftSetOptions,
    ) => void;
    setDraftAnswer: (answers: Answers, options?: DraftSetOptions) => void;
    setDraftErrorMessage: (
      errorMessage: string,
      options?: DraftSetOptions,
    ) => void;
    setDraftSuccessMessage: (
      successMessage: string,
      options?: DraftSetOptions,
    ) => void;
    setDraftComment: (comment: string, options?: DraftSetOptions) => void;
    setDraftGroupId: (options?: DraftSetOptions) => void;
    setActiveTaskTab: (tab: string) => void;
  };
};
